import React, { ReactElement, useCallback, useState } from 'react';

import { useSetRecoilState } from 'recoil';

import debounce from '@common/debounce';
import { css } from '@emotion/react';

import useRouterHook from '@lib/hook/useRouterHook';
import pixelToRem from '@lib/styles/pixelToRem';

import * as SearchAPI from '@api/search/search';

import AutoComplete from './AutoComplete';

import { recentSearchPriceRecordState } from '@recoils/search/atom';

function SearchPriceBar(): ReactElement {
  const { push, queryString } = useRouterHook();
  const priceKeyword = queryString?.searchWord || '';

  const [options, setOptions] = useState<{ id: number; value: string }[]>([]);
  const setSearchRecord = useSetRecoilState(recentSearchPriceRecordState);

  const moveToDetailPricePageOf = (keyword: string) => {
    push(`/search-price?searchWord=${keyword}`);
  };

  const getAutoKeywordList = (inputKeyword: string) =>
    SearchAPI.getRecommendKeywords(inputKeyword);

  /** 검색 키워드 히스토리 저장 */
  const storeSearchRecord = useCallback(
    (keyword: string) => {
      setSearchRecord((prevState) => {
        const newState = [...prevState, { keyword: keyword, idx: Date.now() }];
        localStorage.setItem('searchRecord', JSON.stringify(newState));

        return [...prevState, { keyword: keyword, idx: Date.now() }];
      });
    },
    [setSearchRecord],
  );

  /** 검색 키워드 자동완성 리스트 세팅 */
  const setAutoCompleteList = async (inputKeyword: string) => {
    if (!inputKeyword) {
      setOptions([]);
      return;
    }

    const {
      data: { autoCompleteItemList },
    } = await getAutoKeywordList(inputKeyword);

    if (autoCompleteItemList.length < 1) {
      setOptions([]);
      return;
    }

    const currAutoCompleteItemList = autoCompleteItemList.map(
      (word: { keyword: string }, index) => ({
        id: index,
        value: word.keyword,
      }),
    );

    setOptions(currAutoCompleteItemList);
  };

  return (
    <div css={searchBarWrap}>
      <h2>시세조회</h2>
      <p>
        원하시는 상품은 얼마에{' '}
        <span className="split">거래되고 있는지 알아보세요</span>
      </p>
      <AutoComplete
        value={priceKeyword}
        options={options}
        setSearchRecord={storeSearchRecord}
        setAutoCompleteList={debounce(setAutoCompleteList, 200)}
        placeholder="어떤 상품을 찾으시나요?"
        moveToDetailPricePageOf={moveToDetailPricePageOf}
      />
    </div>
  );
}

const searchBarWrap = css`
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
  max-width: 100vw;
  padding: ${pixelToRem(87, 0, 48, 0)};
  /* z-index: 1000; */

  h2 {
    flex: 0 0 auto;
    font-size: ${pixelToRem(28)};
    margin-bottom: ${pixelToRem(6)};
  }

  p {
    text-align: center;
  }

  /** mobile */
  @media (max-width: 599px) {
    padding: ${pixelToRem(16, 20)};
    height: auto;

    h2,
    p {
      display: none;
    }
  }

  /** tablet */
  @media (min-width: 600px) and (max-width: 1023px) {
    padding: ${pixelToRem(16, 20)};
    height: auto;

    h2,
    p {
      display: none;
    }
  }

  /** PC */
  @media (min-width: 1024px) {
  }
`;
export default SearchPriceBar;
